import AppModalContainer from '@nxsys/components/AppModalContainer';
import { AppDispatch } from '@nxsys/store';
import { createStatutory } from '@nxsys/store/slices/statutory/action';
import { CreateStatutoryParams } from '@nxsys/store/slices/statutory/types';
import {
  FORM_STATUTORY_TYPE,
  STATUTORY_PAYMENT_TYPE,
} from '@nxsys/constants/statutory';
import { Form } from 'antd';
import { useDispatch } from 'react-redux';
import FormStatutory from './FormStatutory';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';

type CreateStatutoryModalProps = {
  isOpen: boolean;
  title: string;
  type: (typeof STATUTORY_PAYMENT_TYPE)[keyof typeof STATUTORY_PAYMENT_TYPE];
  toggle: () => void;
  refetchData: () => void;
};

const CreateStatutoryModal: React.FC<CreateStatutoryModalProps> = ({
  title,
  isOpen,
  toggle,
  type,
  refetchData,
}: CreateStatutoryModalProps) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch<AppDispatch>();
  const { messages } = useTypedIntl();

  const handleSubmit = async (params: CreateStatutoryParams) => {
    await dispatch(createStatutory(params));
    refetchData();
    toggle();
  };

  return (
    <AppModalContainer
      title={title}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.save'],
          buttonType: 'primary',
          onClick: () => form.submit(),
        },
      ]}
      width={900}
    >
      <FormStatutory
        formRef={form}
        formType={FORM_STATUTORY_TYPE.CREATE}
        type={type}
        onSubmit={handleSubmit}
      />
    </AppModalContainer>
  );
};

export default CreateStatutoryModal;
